<template>
  <div>
    <el-table
      border
      :data="list">
      <el-table-column
        label="服务产品"
        prop="serviceCategoryName"> </el-table-column>
      <template>
        <el-table-column
          label="描述"
          width="360"
          prop="features"> </el-table-column>
        <el-table-column
          v-if="service.needConfigPackage === 0"
          label="周期（天）"
          prop="cycleDays">
        </el-table-column>
      </template>
      <el-table-column
        v-if="service.associateIndustryCategory === 1"
        label="关联行业"
        min-width="220"
        prop="cycleDays">
        <template slot-scope="{ row }">
          <div
            v-for="item in row.level2Categorys"
            :key="item.classId">{{ item.fullClassName }}</div>
        </template>
      </el-table-column>
      <el-table-column
        width="140"
        label="图片">
        <template slot-scope="{ row }">
          <el-image
            v-for="item in row.serviceCategoryImage"
            :key="item.url"
            style="width: 110px;"
            :src="item.url"></el-image>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="240">
        <template slot-scope="{ row }">
          <el-button
            type="info"
            @click="updateitem(row)"> 编辑</el-button>
          <el-button
            type="danger"
            @click="deleteitem(row)">删除 </el-button>
          <el-button
            v-if="service.needConfigPackage === 1"
            type="primary"
            @click="viewPackage(row)">套餐管理 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <edit-service-modal
      ref="service"
      :callback="() => { getlist(); } " />
    <package-modal ref="package" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import EditServiceModal from './editServiceModal'
import PackageModal from './package-modal.vue'
import _ from 'lodash'
export default {
  name: 'ServiceTable',
  components: { EditServiceModal, PackageModal },
  props: {
    service: { type: Object, default() { return { } } }
  },
  data() {
    return { loading: true, list: [], config: { }}
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.service.update(_.cloneDeep(row), this.service)
    },
    viewPackage(row) {
      this.$refs.package.init(row)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该服务产品?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('account/deleteservicecategory', {
            payload: { serviceCategoryId: row.serviceCategoryId },
            success: () => {
              this.loading = false
              this.getlist()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getservicecategorys', {
        payload: { serviceId: this.service.serviceId },
        success: (res) => {
          this.loading = false
          this.list = res.data.records.map(i => ({
            ...i,
            cycleDays: i.cycleDays || undefined,
            serviceCategoryImage: i.serviceCategoryImage ? i.serviceCategoryImage.split(',').map(i => ({ url: i })) : [],
            images: this.$splitImage(i.images)
          }))
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
